<template>
    <span class="c-label" :class="label">
        {{value | placeholder}}
    </span>
</template>

<script>
import Column from '@mixins/Column';

export default {
    mixins: [ Column ],
    computed: {
        label() {
            switch (this.value.toLowerCase()) {
                case 'gereed':
                case 'afgerond':
                case 'ready':
                        return 'c-label--success';
                    break;
                case 'in uitvoering':
                case 'in progress':
                        return 'c-label--warning';
                    break;

                case 'geannuleerd':
                case 'cancelled':
                        return 'c-label--alert';
                    break;

                case 'verzoek':
                case 'new':
                        return 'c-label--secondary';
                    break;

                case 'afgekeurd':
                        return 'c-label--tertiary';
                    break;
                default:
                    return '';
            }
        }
    }
}
</script>
